import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { FixturePricingState } from '@cds/betting-offer/add-ons';
import { RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { SmoothScroll } from '@frontend/sports/common/core/feature/smooth-scroll';
import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { WinGameFixturePreview } from '@frontend/sports/racing/feature/models';
import { findIndex } from 'lodash-es';

import { GreyhoundTrackingService } from '../../common/greyhound-tracking.service';

interface DayOfRaceMeetingListComponentViewModel {
    fixtures: {
        fixture: WinGameFixturePreview;
        fixtureUrl: string;
    }[];
}

@Component({
    selector: 'ms-day-of-race-meeting-list',
    templateUrl: 'day-of-race-meeting-list.html',
    standalone: false,
})
export class DayOfRaceMeetingListComponent implements AfterViewInit, OnChanges, OnInit {
    @Input() fixtures: WinGameFixturePreview[];
    @Input() crmPromotedFixtureIdsMap: StringDictionary<string> = {};

    vm: DayOfRaceMeetingListComponentViewModel = { fixtures: [] };

    pricingStates = {
        Resulted: FixturePricingState.Resulted,
        Priced: FixturePricingState.Priced,
        RaceOff: FixturePricingState.RaceOff,
    };

    isGreyhoundsStyle = false;
    countDownTimerSeconds: number;
    constructor(
        private urlHelper: UrlHelperService,
        private smoothScroll: SmoothScroll,
        private elementRef: ElementRef,
        private route: ActivatedRoute,
        private racingConfig: RacingConfig,
        private greyhoundTrackingService: GreyhoundTrackingService,
    ) {
        this.countDownTimerSeconds = this.racingConfig.countdownTimer;
    }

    async ngAfterViewInit(): Promise<void> {
        const index = findIndex(this.fixtures, (x) => x.addons.pricingState !== FixturePricingState.Resulted);

        if (index) {
            // Issue with ExpressionChangedAfterItHasBeenCheckedError
            const scroller = await this.elementRef.nativeElement.querySelector('.scroll-adapter > div');
            const left = scroller.children[0].offsetWidth * index - 50;
            this.smoothScroll.scrollLeftTo(scroller, left, 200);
        }
    }

    ngOnChanges(changes: ISimpleChanges<DayOfRaceMeetingListComponent>): void {
        if (changes.fixtures) {
            const value = changes.fixtures.currentValue || [];
            this.vm = {
                fixtures: value.map((f) => ({
                    fixture: f,
                    fixtureUrl: this.urlHelper.getRacingUrlByFixture(f.sport.id, f),
                })),
            };
        }
    }

    ngOnInit(): void {
        const sportId = this.route.snapshot.data['sport'] === SportConstant.Horses ? SportConstant.Horses : SportConstant.Greyhounds;
        if (sportId === SportConstant.Greyhounds) {
            this.isGreyhoundsStyle = true;
        }
    }

    track(fixture: WinGameFixturePreview) {
        this.greyhoundTrackingService.trackRaceModule(
            fixture,
            this.urlHelper.getRacingUrlByFixture(fixture.sport.id, fixture),
            this.fixtures.indexOf(fixture),
        );
    }
}
